<div class="sidebar" role="dialog">

	<app-sidebar-header 
		[title]="'extrasSidebar.sightseeingTours.title.sightseeingTours' | ibeadmin | async" 
		[label]="'extrasSidebar.sightseeingTours.label.discountVoucher' | ibeadmin | async">
		<div actions>
			<button class="button button--small" 
				(click)="!isModificationDisallowed ? INDRA_handleDone() : INDRA_closeSidebar()"
				*ngIf="INDRA_showDone()" 
				[attr.aria-label]="'extrasSidebar.sightseeingTours.aria.confirmChanges' | ibeadmin | async">		
				{{ 'extrasSidebar.sightseeingTours.label.done' | ibeadmin | async }}
			</button>
		</div>
	</app-sidebar-header>

	<div class="block-stopover">
		<div class="grid">
			<div class="col-12 col-tp-12 col-p-12">
				<app-svg class="icon" svg="icons.svg#services--book_hotel" aria-hidden="true" [alt]="'extrasSidebar.sightseeingTours.alt.partnerStopover' | ibeadmin | async"></app-svg>
				{{ 'extrasSidebar.sightseeingTours.text.stopoverIn' | ibeadmin | async }} {{ 'extrasSidebar.text.countryLisbon' | ibeadmin | async }}
			</div>
		</div>
	</div>

	<div class="sidebar__body sl--scrollable sidebar-wrapper" #sidebar__body>

		<div class="grid no-pad">

			<div #sidebar__info class="sidebar__info col-9 col-tp-9">
				<ul class="vantages-listing">
					<li>{{ 'extrasSidebar.sightseeingTours.text.hopOn' | ibeadmin | async }} {{ 'extrasSidebar.text.countryLisbon' | ibeadmin | async }}</li>
					<li>{{ 'extrasSidebar.sightseeingTours.text.segwayTrips' | ibeadmin | async }} {{ 'extrasSidebar.text.countryLisbon' | ibeadmin | async }}</li>
					<li>{{ 'extrasSidebar.sightseeingTours.text.sightseeingToursOutside' | ibeadmin | async }} {{ 'extrasSidebar.text.countryLisbon' | ibeadmin | async }}</li>
					<li>{{ 'extrasSidebar.sightseeingTours.text.twentyfiveDiscount' | ibeadmin | async }}</li>
				</ul>

				<a class="link link--external bottom-gap display--block" title="Open dialog for All about {{ 'extrasSidebar.text.countryLisbon' | ibeadmin | async }} Sightseeing tours"
					aria-label="'Open dialog for All about ' + ('extrasSidebar.text.countryLisbon' | ibeadmin | async) + ' Sightseeing tours'" href="javascript:;"
					(click)="INDRA_gotoURL()">
					{{ 'extrasSidebar.sightseeingTours.text.allAbout' | ibeadmin | async }} {{ 'extrasSidebar.text.countryLisbon' | ibeadmin | async }} {{
					'extrasSidebar.sightseeingTours.title.sightseeingTours' | ibeadmin | async }}
				</a>

			</div>

			<!-- <div class="block-partner col-3 col-tp-3">
				<div class="block-partner__title">
					{{ 'extrasSidebar.sightseeingTours.text.withPartner' | ibeadmin | async }}
				</div>
				<app-svg class="icon" svg="sprite.svg#airlines--0O" aria-hidden="true" [alt]="'extrasSidebar.sightseeingTours.alt.partnerStopover' | ibeadmin | async"></app-svg>
			</div> -->

		</div>

		<ng-container *ngIf="hasError">
			<div class="container">
				<app-notification [style]="'alert'" [icon]="'icons.svg#airport--delays'" 
					[title]="'extrasSidebar.sightseeingTours.title.internalError' | ibeadmin | async">
					<div message>
						<span>
							{{ 'extrasSidebar.sightseeingTours.text.internalErrorOccurred' | ibeadmin | async }}
						</span>
					</div>
				</app-notification>
			</div>
		</ng-container>
		
		<div class="no-padding">

			<article class="ancillary-block-sightseeing" [ngClass]="{ 'is-active': INDRA_isActive(ancillary) }" tabindex=0 [attr.aria-label]="INDRA_ariaLabel(ancillary)" *ngFor="let ancillary of ancillaries">

				<div class="ancillary-block-sightseeing__left" aria-hidden=true>
					<div class="ancillary-block-sightseeing__image" [style.background-image]="INDRA_printImage(ancillary)">
						<app-svg aria-hidden="true" *ngIf="INDRA_isActive(ancillary)" [svg]="'icons.svg#general--check'" class="icon white" [alt]="ancillary.title + 'extrasSidebar.sightseeingTours.alt.icon' | ibeadmin | async"></app-svg>
					</div>

				</div>

				<div class="ancillary-block-sightseeing__right" aria-hidden=true>
					<div class="ancillary-block-sightseeing__text">

						<div class="ancillary-block-sightseeing__text-top">
							<h5 class="ancillary-block-sightseeing__title">
								{{ ancillary.title | ibeadmin | async }}
							</h5>
							<div class="ancillary-block-sightseeing__text">
								{{ ancillary.description | ibeadmin | async }}
								<a *ngIf="ancillary.id === 'hop-on-hop-off'" class="link link--external display--block"
									(click)="INDRA_openUrl('externalURLs.hopOnHopOff')"
									[attr.aria-label]="('extrasSidebar.sightseeingTours.aria.openNewWindow' | ibeadmin | async) + ancillary.label" 
									href="javascript:;">
									{{ 'extrasSidebar.sightseeingTours.aria.allAbout' | ibeadmin | async }} {{ ancillary.label }}
								</a>
							</div>
						</div>

						<div class="ancillary-block-sightseeing__text-bottom">

							<div class="ancillary-block-sightseeing__discount">
								<p class="ancillary-block-sightseeing__discount__text">{{ ancillary.discount | ibeadmin | async }} </p>
								<p class="ancillary-block-sightseeing__discount__muted">{{ ancillary.cash.label_prefix | ibeadmin | async }}</p>
							</div>

							<button class="button button--small ancillary-block-sightseeing__button" 
								(click)="INDRA_addAncillary(ancillary)" 
								*ngIf="!isModificationDisallowed && !INDRA_isActive(ancillary)" 
								[attr.aria-label]="'extrasSidebar.sightseeingTours.aria.addDiscount' | ibeadmin | async">
								{{ 'extrasSidebar.sightseeingTours.label.addDiscount' | ibeadmin | async }}
							</button>

							<ng-container *ngIf="!isModificationDisallowed && !extra[0]['readOnly']">
								<div class="ancillary-block-sightseeing__button--added align-right" 
									(click)="INDRA_removeAncillary(ancillary)" 
									*ngIf="INDRA_isActive(ancillary)" 
									role="button" 
									[attr.aria-label]="'extrasSidebar.sightseeingTours.aria.removeExtra' | ibeadmin | async" 
									tabindex="0">
									<label>
										{{ 'extrasSidebar.sightseeingTours.label.remove' | ibeadmin | async }}
									</label>
									<app-svg svg="icons.svg#general--close" class="close-icon" 
										[alt]="'extrasSidebar.sightseeingTours.aria.removeExtra' | ibeadmin | async" 
										aria-hidden="true">
									</app-svg>
								</div>
							</ng-container>


						</div>

					</div>
				</div>

			</article>


		</div>

		<hr class="separator" aria-hidden="true">

		<ng-container *ngIf="INDRA_showDone()">
			<div class="sidebar__totals">
				<div class="total">
					<label class="label">{{ INDRA_countActive() }} items</label>
					<p class="value">{{ INDRA_sumAncillary() | indracurrency : currencyCode }}</p>

				</div>

				<p class="muted">
					{{ 'extrasSidebar.sightseeingTours.text.discountVoucherFree' | ibeadmin | async }}<br> {{ 'extrasSidebar.sightseeingTours.text.grayLinePortugal' | ibeadmin | async }}
				</p>

			</div>

			<button class="button full-width button--small" 
				(click)="!isModificationDisallowed ? INDRA_handleDone() : INDRA_closeSidebar()" 
				[attr.aria-label]="'extrasSidebar.sightseeingTours.aria.confirmAddedBags' | ibeadmin | async">
				{{ 'extrasSidebar.sightseeingTours.label.done' | ibeadmin | async }}
			</button>


			<div class="conditions">
				<h3 class="title-h3 conditions__title">{{ 'extrasSidebar.sightseeingTours.text.conditions' | ibeadmin | async }}</h3>
				<div class="conditions__text">
					<div class="grid">
						<div class="col-12">
							<ul class="bullet-list">
								<li>
									{{ 'extrasSidebar.sightseeingTours.text.toBenefitFromTheOffer' | ibeadmin | async }}
									<a
										class="link"
										target=”_blank”
										href="{{ 'externalURLs.cityrama' | ibeadmincfg }}"
										[attr.aria-label]="'extrasSidebar.sightseeingTours.label.openCityrama' | ibeadmin | async"
									>
										{{ 'extrasSidebar.sightseeingTours.text.openCityrama' | ibeadmin | async }}
									</a>
								</li>
								<li>{{ 'extrasSidebar.sightseeingTours.text.tapsPartner' | ibeadmin | async }}</li>
								<li>{{ 'extrasSidebar.sightseeingTours.text.allPayments' | ibeadmin | async }}</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</ng-container>

	</div>
</div>
